var path = '/app/components/ui/puzzle/puzzle.html';
var html = "<div class=puzzle ng-class=\"{ 'transparent':  $ctrl.transparent }\"> <div class=part ng-class=\"{ 'collected': t.collected }\" data-background=\"{{ t.collected ? $ctrl.puzzle[$index] : '' }}\" ng-repeat=\"t in $ctrl.throphies\"></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/puzzle/puzzle.html
// module id = 192
// module chunks = 0